module.exports = __webpack_public_path__ + "img/warehouse3.f56f7407.png";